import axios from 'axios'
import router from '@/router'
import store from '@/store'
import { auth, user } from '@/services'

const renewAuthHeaders = async (response) => {
  const headers = response?.headers || {}

  if (headers['access-token'] && headers['expiry']) {
    const data = Object.assign(user.getUserData(), {
      headers: {
        'access-token': headers['access-token'],
        'token-type': headers['token-type'],
        'client': headers['client'],
        'expiry': headers['expiry'],
        'uid': headers['uid']
      }
    })

    auth.setUserAuthData(data)
  }
}

const connectionProxy = axios.create({
  baseURL: `${process.env.VUE_APP_API_URL}/${process.env.VUE_APP_API_VERSION}`,
  timeout: 10000
})

connectionProxy.interceptors.request.use(async (config) => {
  config.headers = auth.getUserAuthData() || {}
  config.params = {}
  return config
}, (error) => {
  return Promise.reject(error)
})

connectionProxy.interceptors.response.use(async (response) => {
  if (auth.getUserAuthData()) {
    renewAuthHeaders(response)
  }

  return response
}, (error) => {
  const handle401 = () => {
    store.dispatch('snackbar/showSnack', 'Sessão expirada.')
    store.dispatch('auth/logout')
    router.push('/login')
  }

  const handleRenewHeaders = () => {
    if (auth.getUserAuthData()) {
      renewAuthHeaders((error || {}).response || {})
    }
  }

  ((error || {}).response || {}).status !== 401 ? handleRenewHeaders() : handle401()

  return Promise.reject(error)
})

export default connectionProxy
